import React from 'react'

import IndentOptionsSelect from '../../../components/modules/IndentOptionsSelect'
import TextToTextTransformerLayout from '../../../components/layouts/TextToTextTransformerLayout'


export default function TextConverterLayout({
                                              convert,
                                              indentOptionsEnabled = true,
                                              defaultInputOption = {
                                                useTabs: false,
                                                tabWidth: 4,
                                              },
                                              indentSupportTab = true,
                                            }) {

  const [textInput, setTextInput] = React.useState('')
  const onTextInputChange = (textInput) => {
    setTextInput(textInput)
  }

  const [options, setOptions] = React.useState(defaultInputOption)
  const onIndentOptionsChange = (indentOptions) => {
    setOptions({...options, ...indentOptions})
  }

  const convertFunc = React.useCallback((textInput) => {
    return convert(textInput, options)
  }, [convert, options])

  return (
    <TextToTextTransformerLayout
      transform={convertFunc}
      inputExtraControl={
        indentOptionsEnabled ? (
          <IndentOptionsSelect
            currentIndentOptions={options}
            onIndentOptionsChange={onIndentOptionsChange}
            supportTab={indentSupportTab}
          />
        ) : undefined
      }
    />
  )
}
